module.exports = __webpack_public_path__ + "static/media/small_mercedes.9867185e.png";